import { Item, Resource } from '../../crud-graphql-containers/Utils/genericTypes';

export function linkToEditForm(resource: Resource, item: Item, queryParams: string) {
  if (!resource) {
    return;
  }
  const { keyProperty = 'id' } = resource;
  return `/${resource.basePath}/${encodeURIComponent(item[keyProperty])}${queryParams}`;
}

export function linkToList(resource: Resource) {
  return `/${resource.basePath}/list`;
}
